// The GTM dataLayer and the gtag() command shim (#1458).

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export const GTM_SCRIPT_ID = 'reed-gtm';

export function dataLayer(win: Window = window): unknown[] {
  win.dataLayer = win.dataLayer ?? [];
  return win.dataLayer;
}

export function pushDataLayer(entry: Record<string, unknown>, win: Window = window): void {
  dataLayer(win).push(entry);
}

/**
 * gtag() must push the arguments object itself, not an array: GTM only treats
 * Arguments entries as commands (consent, set, get).
 */
export function gtag(..._args: unknown[]): void {
  dataLayer().push(arguments);
}

export function loadGtm(
  gtmId: string,
  envQuery: string | undefined,
  doc: Document = document,
): void {
  if (doc.getElementById(GTM_SCRIPT_ID)) {
    return;
  }
  pushDataLayer({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const script = doc.createElement('script');
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}${envQuery ?? ''}`;
  doc.head.appendChild(script);
}
